import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrOperationAddrGet, SrOperationResourceItem, SrOperationService } from '@app/services/sr-operation.service';

@Component({
    selector: 'tt-sr-operation-addr',
    templateUrl: './sr-operation-addr.component.html',
    styleUrls: ['./sr-operation-addr.component.css'],
    standalone: false,
})
export class SrOperationAddrComponent implements OnInit {
    public page?: SrOperationAddrGet;
    public resources: SrOperationResourceItem[] = [];
    public checklists: Item[] = [];
    public saving = false;

    constructor(
        private readonly operation: SrOperationService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.operation.getReport({ custact_no: String(this.navigator?.params['custact_no'] ?? '') });
        [this.resources, this.checklists] = await Promise.all([
            this.page.custact_no?.trim() ? this.operation.getReportResources({ custact_no: this.page.custact_no }) : Promise.resolve([]),
            this.operation.getReportChecklists(this.page),
        ]);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const response = await this.operation.saveReport(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
